/*
 * @Description: 
 * @Date: 2019-10-24 10:58:17
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-25 10:17:38
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Login',
        component: () =>
            import ('../views/Login.vue')
    }, {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/SubmitReview',
        name: 'SubmitReview',
        component: () =>
            import ('../views/SubmitReview.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router